export default __webpack_public_path__ + "static/media/lorry.e65c0de9.png";